require('normalize.css/normalize.css');
require('animate.css/animate.min.css');
require('styles/App.css');
require('../../node_modules/chart.js/Chart.js');

import React from 'react';
import { Link } from 'react-router-dom';
import { Line } from 'react-chartjs';
import LoadingComponent from './LoadingComponent';
import ArticlesListComponent from './ArticlesListComponent';
import BrandsListComponent from './BrandsListComponent';
import NewArticleComponent from './NewArticleComponent';
import NewBrandComponent from './NewBrandComponent';
import NewCategoryComponent from './NewCategoryComponent';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false, //TODO: Update styles for loading and handle loading ending
      newArticle: null,
      newCategory: null,
      newBrand: null
    };
  }

  componentDidMount() {
    let filename = "http://www.wblocks.com/hondaAPI/notification";
    var source = new EventSource('http://www.wblocks.com/hondaAPI/utils/notification.util.php?brandId=' + this.props.match.params.brandId);
    source.onmessage = function (e) {
      if (!('Notification' in window)) {
        alert('This browser does not support desktop notification');
      }

      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        var notification = new Notification('Se necesita vendedor:',
          {
            body: e.data,
            dir: 'auto', // or ltr, rtl
            lang: 'EN', //lang used within the notification.
            icon: '' //The URL of an image to be used as an icon
          }
        );
        document.getElementById("sound").innerHTML = '<audio autoplay="autoplay"><source src="' + filename + '.wav" type="audio/wav" /><embed hidden="true" autostart="true" loop="false" src="' + filename + '.wav" /></audio>';
      }

      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            var notification = new Notification('Hi there!');
          }
        });
      }
    };
  }

  _openNewArticleModal() {
    this.setState({
      newArticle: <NewArticleComponent cancelModal={this._onCancelModal.bind(this, '#createArticle')} articleSaved={this._onNewArticleCreated.bind(this, '#createArticle')} />
    });
    setTimeout(() => {
      $('#createArticle').modal({
        dismissible: false
      });
      $('#createArticle').modal('open');
    }, 200);
  }

  _openNewBrandModal() {
    this.setState({
      newBrand: <NewBrandComponent cancelModal={this._onCancelModal.bind(this, '#createBrand')} brandSaved={this._onNewArticleCreated.bind(this, '#createBrand')} />
    });
    setTimeout(() => {
      $('#createBrand').modal({
        dismissible: false
      });
      $('#createBrand').modal('open');
    }, 200);
  }

  _openNewCategoryModal() {
    this.setState({
      newCategory: <NewCategoryComponent cancelModal={this._onCancelModal.bind(this, '#createCategory')} categorySaved={this._onNewArticleCreated.bind(this, '#createCategory')} />
    });
    setTimeout(() => {
      $('#createCategory').modal({
        dismissible: false
      });
      $('#createCategory').modal('open');
    }, 200);
  }

  _onNewArticleCreated(id) {
    $(id).modal('close');
    this.setState({
      newArticle: null,
      newCategory: null,
      newBrand: null
    });
  }

  _onCancelModal(id) {
    $(id).modal('close');
    this.setState({
      newArticle: null,
      newCategory: null,
      newBrand: null
    });
  }

  render() {
    let { loading } = this.state;

    return (
      <div className="index">
        <div id="sound"></div>
        <header>
          <ul id="nav-mobile" className="side-nav fixed">
            <li className="logo"><a id="logo-container" className="brand-logo"></a></li>
            <li><a onClick={this._openNewBrandModal.bind(this)}>Agregar nuevo Sucursal</a></li>
            <li><a onClick={this._openNewArticleModal.bind(this)}>Agregar nueva Artículo</a></li>
            <li><a onClick={this._openNewCategoryModal.bind(this)}>Agregar nueva Categoría</a></li>
            <li><Link to="/">Configuración</Link></li>
          </ul>
        </header>
        {loading ? <LoadingComponent /> : ''}
        <main>
          <div className="wrapper-container">
            {this.state.newArticle}
            {this.state.newBrand}
            {this.state.newCategory}
            <div className="row">
              <div className="col s12">
                <header>
                  <h5>Estadísticas</h5>
                </header>
                <StatisticsComponent />
              </div>
            </div>
            <div className="row">
              <div className="col s12">
                <header>
                  <h5>Artículos</h5>
                </header>
                <ArticlesListComponent />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m6">
                <header>
                  <h5>Sucusales</h5>
                </header>
                <BrandsListComponent />
              </div>
              <div className="col s12 m6">
                <header>
                  <h5>Categorías</h5>
                </header>
                <BrandsListComponent />
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

import TotemStore from '../stores/TotemStore';

class StatisticsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: []
    };
  }

  componentDidMount() {
    TotemStore.on('ARTICLES_RECEIVED', this._onReceiveArticles.bind(this));
  }

  _onReceiveArticles() {
    this.setState({
      articles: TotemStore.getArticles()
    })
  }

  render() {
    let { articles } = this.state;

    if (articles) {
      var lineChartData = {
        labels: ["Vistas", "Llamado", "Comprar"],
        datasets: []
      }
      articles.forEach((article) => {
        lineChartData.datasets.push({
          label: article.name,
          fillColor: "rgba(202, 31, 31, 0.2)",
          strokeColor: "rgba(202, 31, 31,.1)",
          pointColor: "rgba(202, 31, 31, .1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(202, 31, 31,.1)",
          data: [article.views, article.attendant, article.clicks]
        });
      });
    }

    let body = articles ? <Line data={lineChartData} width="600" height="250" redraw/> : '';

    return (
      <div>
        {body}
      </div>
    );
  }

}

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js